export default __webpack_public_path__ + "static/media/teamLeftarrow.c775d4f2.svg";